import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export type TermsOfUseDoc = {
    _id?: string;
    key?: string;
    /** Single shared title (not multilingual) */
    title?: string;
    content?: Record<string, string>;
    version?: string;
    updated_at?: number;
    created_at?: number;
};

export type TermsOfUsePublic = {
    title: string;
    content: string;
    version?: string;
    lang?: string;
    updated_at?: number;
};

@Injectable({
    providedIn: 'root',
})
export class TermsOfUseService {
    constructor(private http: HttpClient) {}

    /** Admin — full document (title string + multilingual content) of a brand's terms (#183) */
    get(brand?: string): Observable<TermsOfUseDoc> {
        const params = brand ? new HttpParams().set('brand', brand) : undefined;
        return this.http.get<TermsOfUseDoc>(`${environment.apiUrl}terms-of-use`, { params });
    }

    /** Admin — upsert the brand's document (#183; default: Immosurance) */
    save(data: Partial<TermsOfUseDoc>, brand?: string): Observable<TermsOfUseDoc> {
        return this.http.put<TermsOfUseDoc>(`${environment.apiUrl}terms-of-use`, { ...data, ...(brand ? { brand } : {}) });
    }

    /** Public — signup / footer dialog (no auth) */
    getPublic(lang: string): Observable<TermsOfUsePublic> {
        const params = new HttpParams().set('lang', lang || 'en');
        return this.http.get<TermsOfUsePublic>(`${environment.apiUrl}terms-of-use/public`, {
            params,
        });
    }
}
